import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loader-button',
  templateUrl: './loader-button.component.html',
  styleUrls: ['./loader-button.component.scss'],
  standalone: true,
  imports: [MatButton, MatProgressSpinner],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderButtonComponent {
  @Input({ required: true }) loading = false;

  @Input() disabled = false;

  @Input() color: 'primary' | 'accent' | 'warn' | undefined;

  @Input() type: 'submit' | 'button' | 'reset' = 'button';
}
